/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetUserForMagicQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetUserForMagicQuery = {
  readonly __typename: "Query";
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly userMagicConfig: c.UserMagicConfig;
  } | null;
};

export type CancelMagicMutationVariables = Types.Exact<{
  id: Types.Scalars["MagicEventId"]["input"];
}>;

export type CancelMagicMutation = {
  readonly __typename: "Mutation";
  readonly cancelMagicRequest: string;
};

export type ResumeChainMutationVariables = Types.Exact<{
  id: Types.Scalars["MagicEventId"]["input"];
  startingCellId: Types.InputMaybe<Types.Scalars["CellId"]["input"]>;
  startingCellContents: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type ResumeChainMutation = {
  readonly __typename: "Mutation";
  readonly resumeMagicChain: {
    readonly __typename: "GenerateCellsResult";
    readonly magicEvent: {
      readonly __typename: "MagicEvent";
      readonly id: c.MagicEventId;
    };
  };
};

export type GenerateChainMutationVariables = Types.Exact<{
  prompt: Types.Scalars["String"]["input"];
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  cellOrder: Types.Scalars["String"]["input"];
  mentionedTableIds:
    | ReadonlyArray<Types.Scalars["DataSourceTableId"]["input"]>
    | Types.Scalars["DataSourceTableId"]["input"];
  richTextPrompt: Types.InputMaybe<Types.Scalars["RichTextDocument"]["input"]>;
  mentionedDataframes:
    | ReadonlyArray<Types.Scalars["MentionedDataframeName"]["input"]>
    | Types.Scalars["MentionedDataframeName"]["input"];
  dataConnectionId: Types.InputMaybe<
    Types.Scalars["DataConnectionId"]["input"]
  >;
  cellId: Types.Scalars["CellId"]["input"];
  blockCellId: Types.Scalars["BlockCellId"]["input"];
  parentEventId: Types.Scalars["MagicEventId"]["input"];
  eventSource: Types.InputMaybe<Types.MagicEventSource>;
}>;

export type GenerateChainMutation = {
  readonly __typename: "Mutation";
  readonly magicGenerateCells: {
    readonly __typename: "GenerateCellsResult";
    readonly magicEvent: {
      readonly __typename: "MagicEvent";
      readonly id: c.MagicEventId;
    };
  };
};

export type EditCellSyncMutationVariables = Types.Exact<{
  magicEventId: Types.Scalars["MagicEventId"]["input"];
  cellId: Types.Scalars["CellId"]["input"];
  kind: Types.MagicCellEditWithInput;
  customInstruction: Types.Scalars["String"]["input"];
  chartType: Types.InputMaybe<Types.ChartType>;
  sourceEventId: Types.InputMaybe<Types.Scalars["MagicEventId"]["input"]>;
  mentionedTableIds:
    | ReadonlyArray<Types.Scalars["DataSourceTableId"]["input"]>
    | Types.Scalars["DataSourceTableId"]["input"];
  richTextPrompt: Types.InputMaybe<Types.Scalars["RichTextDocument"]["input"]>;
  mentionedDataframes:
    | ReadonlyArray<Types.Scalars["MentionedDataframeName"]["input"]>
    | Types.Scalars["MentionedDataframeName"]["input"];
  timezone: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type EditCellSyncMutation = {
  readonly __typename: "Mutation";
  readonly editCellSync: {
    readonly __typename: "EditCellSyncResult";
    readonly error: boolean;
    readonly errorType: Types.MagicEventFailureReason | null;
    readonly user: {
      readonly __typename: "User";
      readonly id: c.UserId;
      readonly overMagicUsageLimit: boolean;
    };
  };
};

export const GetUserForMagicDocument = /*#__PURE__*/ gql`
  query GetUserForMagic {
    me {
      id
      userMagicConfig
    }
  }
`;

/**
 * __useGetUserForMagicQuery__
 *
 * To run a query within a React component, call `useGetUserForMagicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForMagicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForMagicQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserForMagicQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserForMagicQuery,
    GetUserForMagicQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserForMagicQuery, GetUserForMagicQueryVariables>(
    GetUserForMagicDocument,
    options,
  );
}
export function useGetUserForMagicLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserForMagicQuery,
    GetUserForMagicQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserForMagicQuery,
    GetUserForMagicQueryVariables
  >(GetUserForMagicDocument, options);
}
export function useGetUserForMagicSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserForMagicQuery,
    GetUserForMagicQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUserForMagicQuery,
    GetUserForMagicQueryVariables
  >(GetUserForMagicDocument, options);
}
export type GetUserForMagicQueryHookResult = ReturnType<
  typeof useGetUserForMagicQuery
>;
export type GetUserForMagicLazyQueryHookResult = ReturnType<
  typeof useGetUserForMagicLazyQuery
>;
export type GetUserForMagicSuspenseQueryHookResult = ReturnType<
  typeof useGetUserForMagicSuspenseQuery
>;
export type GetUserForMagicQueryResult = Apollo.QueryResult<
  GetUserForMagicQuery,
  GetUserForMagicQueryVariables
>;
export const CancelMagicDocument = /*#__PURE__*/ gql`
  mutation cancelMagic($id: MagicEventId!) {
    cancelMagicRequest(id: $id)
  }
`;
export type CancelMagicMutationFn = Apollo.MutationFunction<
  CancelMagicMutation,
  CancelMagicMutationVariables
>;

/**
 * __useCancelMagicMutation__
 *
 * To run a mutation, you first call `useCancelMagicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMagicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMagicMutation, { data, loading, error }] = useCancelMagicMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelMagicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelMagicMutation,
    CancelMagicMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelMagicMutation, CancelMagicMutationVariables>(
    CancelMagicDocument,
    options,
  );
}
export type CancelMagicMutationHookResult = ReturnType<
  typeof useCancelMagicMutation
>;
export type CancelMagicMutationResult =
  Apollo.MutationResult<CancelMagicMutation>;
export type CancelMagicMutationOptions = Apollo.BaseMutationOptions<
  CancelMagicMutation,
  CancelMagicMutationVariables
>;
export const ResumeChainDocument = /*#__PURE__*/ gql`
  mutation resumeChain(
    $id: MagicEventId!
    $startingCellId: CellId
    $startingCellContents: String
  ) {
    resumeMagicChain(
      parentEventId: $id
      startingCellId: $startingCellId
      startingCellContents: $startingCellContents
    ) {
      magicEvent {
        id
      }
    }
  }
`;
export type ResumeChainMutationFn = Apollo.MutationFunction<
  ResumeChainMutation,
  ResumeChainMutationVariables
>;

/**
 * __useResumeChainMutation__
 *
 * To run a mutation, you first call `useResumeChainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeChainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeChainMutation, { data, loading, error }] = useResumeChainMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startingCellId: // value for 'startingCellId'
 *      startingCellContents: // value for 'startingCellContents'
 *   },
 * });
 */
export function useResumeChainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResumeChainMutation,
    ResumeChainMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResumeChainMutation, ResumeChainMutationVariables>(
    ResumeChainDocument,
    options,
  );
}
export type ResumeChainMutationHookResult = ReturnType<
  typeof useResumeChainMutation
>;
export type ResumeChainMutationResult =
  Apollo.MutationResult<ResumeChainMutation>;
export type ResumeChainMutationOptions = Apollo.BaseMutationOptions<
  ResumeChainMutation,
  ResumeChainMutationVariables
>;
export const GenerateChainDocument = /*#__PURE__*/ gql`
  mutation generateChain(
    $prompt: String!
    $hexVersionId: HexVersionId!
    $cellOrder: String!
    $mentionedTableIds: [DataSourceTableId!]!
    $richTextPrompt: RichTextDocument
    $mentionedDataframes: [MentionedDataframeName!]!
    $dataConnectionId: DataConnectionId
    $cellId: CellId!
    $blockCellId: BlockCellId!
    $parentEventId: MagicEventId!
    $eventSource: MagicEventSource
  ) {
    magicGenerateCells(
      prompt: $prompt
      hexVersionId: $hexVersionId
      cellOrder: $cellOrder
      chain: null
      cellType: null
      mentionedTableIds: $mentionedTableIds
      mentionedDataframes: $mentionedDataframes
      richTextPrompt: $richTextPrompt
      dataConnectionId: $dataConnectionId
      cellId: $cellId
      blockCellId: $blockCellId
      parentEventId: $parentEventId
      eventSource: $eventSource
    ) {
      magicEvent {
        id
      }
    }
  }
`;
export type GenerateChainMutationFn = Apollo.MutationFunction<
  GenerateChainMutation,
  GenerateChainMutationVariables
>;

/**
 * __useGenerateChainMutation__
 *
 * To run a mutation, you first call `useGenerateChainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateChainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateChainMutation, { data, loading, error }] = useGenerateChainMutation({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      hexVersionId: // value for 'hexVersionId'
 *      cellOrder: // value for 'cellOrder'
 *      mentionedTableIds: // value for 'mentionedTableIds'
 *      richTextPrompt: // value for 'richTextPrompt'
 *      mentionedDataframes: // value for 'mentionedDataframes'
 *      dataConnectionId: // value for 'dataConnectionId'
 *      cellId: // value for 'cellId'
 *      blockCellId: // value for 'blockCellId'
 *      parentEventId: // value for 'parentEventId'
 *      eventSource: // value for 'eventSource'
 *   },
 * });
 */
export function useGenerateChainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateChainMutation,
    GenerateChainMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateChainMutation,
    GenerateChainMutationVariables
  >(GenerateChainDocument, options);
}
export type GenerateChainMutationHookResult = ReturnType<
  typeof useGenerateChainMutation
>;
export type GenerateChainMutationResult =
  Apollo.MutationResult<GenerateChainMutation>;
export type GenerateChainMutationOptions = Apollo.BaseMutationOptions<
  GenerateChainMutation,
  GenerateChainMutationVariables
>;
export const EditCellSyncDocument = /*#__PURE__*/ gql`
  mutation EditCellSync(
    $magicEventId: MagicEventId!
    $cellId: CellId!
    $kind: MagicCellEditWithInput!
    $customInstruction: String!
    $chartType: ChartType
    $sourceEventId: MagicEventId
    $mentionedTableIds: [DataSourceTableId!]!
    $richTextPrompt: RichTextDocument
    $mentionedDataframes: [MentionedDataframeName!]!
    $timezone: String
  ) {
    editCellSync(
      magicEventId: $magicEventId
      cellId: $cellId
      kind: $kind
      customInstruction: $customInstruction
      chartType: $chartType
      sourceEventId: $sourceEventId
      mentionedTableIds: $mentionedTableIds
      richTextPrompt: $richTextPrompt
      mentionedDataframes: $mentionedDataframes
      timezone: $timezone
    ) {
      error
      errorType
      user {
        id
        overMagicUsageLimit
      }
    }
  }
`;
export type EditCellSyncMutationFn = Apollo.MutationFunction<
  EditCellSyncMutation,
  EditCellSyncMutationVariables
>;

/**
 * __useEditCellSyncMutation__
 *
 * To run a mutation, you first call `useEditCellSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCellSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCellSyncMutation, { data, loading, error }] = useEditCellSyncMutation({
 *   variables: {
 *      magicEventId: // value for 'magicEventId'
 *      cellId: // value for 'cellId'
 *      kind: // value for 'kind'
 *      customInstruction: // value for 'customInstruction'
 *      chartType: // value for 'chartType'
 *      sourceEventId: // value for 'sourceEventId'
 *      mentionedTableIds: // value for 'mentionedTableIds'
 *      richTextPrompt: // value for 'richTextPrompt'
 *      mentionedDataframes: // value for 'mentionedDataframes'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useEditCellSyncMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCellSyncMutation,
    EditCellSyncMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditCellSyncMutation,
    EditCellSyncMutationVariables
  >(EditCellSyncDocument, options);
}
export type EditCellSyncMutationHookResult = ReturnType<
  typeof useEditCellSyncMutation
>;
export type EditCellSyncMutationResult =
  Apollo.MutationResult<EditCellSyncMutation>;
export type EditCellSyncMutationOptions = Apollo.BaseMutationOptions<
  EditCellSyncMutation,
  EditCellSyncMutationVariables
>;
